// extracted by mini-css-extract-plugin
export default {"mobile":"style_mobile__jzNQm","open":"style_open__L2Rjl","wrapper":"style_wrapper__+-wDU","laptop":"style_laptop__iMiqT"};